export const normalizeAccountIds = (accountIds: string[]) => {
  return Array.from(
    new Set(
      accountIds.map((accountId) => accountId.trim()).filter((accountId) => accountId.length > 0),
    ),
  );
};
